import { Badge } from "./styled";

const StatusBadge = ({ children, status }) => {
  return <Badge status={status}>{children}</Badge>;
};

export default StatusBadge;
